<template>
  <auth-template>
    <account-creating-animation slot="overlay" />
    <account-creating-poster slot="poster" />

    <template slot="information">
      <p>{{ $t('from.social.medias.to.site') }}</p>
      <p>{{ $t('common.green') }}</p>
    </template>

    <div :class="$style.container">
      <div class="layout-background">

      </div>

      <div :class="$style.header">
        <auth-header :title="$t('where.to.start.recieve.payments')" />
      </div>

      <div :class="$style.form">
        <account-creating-form
          :loading="loading"
          @submit="handleSubmit"
        />
      </div>
    </div>
  </auth-template>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import AccountCreatingAnimation from '@/resources/tilda/CreateProjectAnimation';
import AccountCreatingPoster from 'molecules/auth/AccountCreatingPoster';
import AccountCreatingForm from 'organisms/auth/AccountCreatingForm';
import AuthHeader from 'organisms/auth/AuthHeader';
import AuthTemplate from 'templates/AuthTemplate';

export default {
  name: 'AccountCreatingView',
  components: {
    AccountCreatingAnimation,
    AccountCreatingPoster,
    AccountCreatingForm,
    AuthHeader,
    AuthTemplate,
  },
  head: {
    script: [
      {
        inner: '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");ym(56244937, "init", {clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});',
        type: 'text/javascript',
      },
      {
        inner: '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,"script","https://connect.facebook.net/en_US/fbevents.js");fbq("init", "1175137569342493");fbq("track", "PageView");',
        type: 'text/javascript',
      },
      {
        inner: '!function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="https://vk.com/js/api/openapi.js?167",t.onload=function(){VK.Retargeting.Init("VK-RTRG-470699-8QMTl"),VK.Retargeting.Hit()},document.head.appendChild(t)}();',
        type: 'text/javascript',
      },
      {
        inner: 'gtag("event", "conversion", {"send_to": "AW-659411109/993LCMCt9csBEKWht7oC"});',
        type: 'text/javascript',
      },
      {
        inner: '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer","GTM-WKBLDC4");',
        type: 'text/javascript',
      },
    ],
    noscript: [
      {
        inner: '<div><img src="https://mc.yandex.ru/watch/56244937" style="position:absolute; left:-9999px;" alt="" /></div>"/>',
      },
      {
        inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1175137569342493&ev=PageView&noscript=1"/>',
      },
      {
        inner: '<img src="https://vk.com/rtrg?p=VK-RTRG-470699-8QMTl" style="position:fixed; left:-999px;" alt=""/>',
      },
      {
        inner: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WKBLDC4" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
      },
    ],
  },
  mounted() {
    // eslint-disable-next-line no-undef
    fbq('track', 'CustomizeProduct');
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState(['REGISTRATION']),
  },
  methods: {
    // TODO: @danealton это очень сложный метод, надо переписать
    getProjectName(link) {
      // обрезает <http?s> и всё после последней точки
      let s = link.replace(/http:\/\/|https:\/\//g, '');
      let l = s.split('.');
      return l.length > 2 ? l.reduce((prev, curr, i) => {
        if (i === l.length - 1) {
          return prev;
        }
        prev = prev ? prev + '.' : '';
        return prev + curr;
      }, '') : l[0];
    },
    async handleSubmit(data) {
      // eslint-disable-next-line no-undef
      ym(56244937, 'reachGoal', 'setprojectlink');

      this.loading = true;

      this.SET_REGISTRATION_PROCESS({
        state: 'PROJECT_LINK',
        data: data.link,
      });

      this.SET_REGISTRATION_PROCESS({
        state: 'PROJECT_NAME',
        data: this.getProjectName(data.link),
      });

      // TODO: CPME-1234 временно отменяем привязку карты на этапе регистрации пользователя
      // this.$router.push({ name: 'cardBinding' });

      if (!this.REGISTRATION.LOGIN || !this.REGISTRATION.PROJECT_NAME) {
        this.$alert({
          type: 'warning',
          text: this.$t('enter.email.and.project.name'),
        });

        this.$router.push({ name: 'registration' });
        return false;
      }

      this.$router.push({ name: 'registration.currency', params: { destination: 'merchant' } });
    },
    ...mapMutations(['SET_REGISTRATION_PROCESS']),
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .header
    margin-bottom: 20px

    +respond-to('small')
      margin-bottom: 50px

  .form
    margin-bottom: 60px

    +respond-to('medium')
      margin-bottom: 0
</style>
